export default "__VITE_ASSET__CbHJng0s__"